export default "__VITE_ASSET__CeRgnDni__"